import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { get_news_illustration } from '../../api/functions';
import { useEffect, useState } from 'react';
import { useApi } from '../../api/api';
import './NewsCard.css';

const NewsCard = ({ news, index }) => {
  const { t, i18n } = useTranslation();
  const [imageUrl, setImageUrl] = useState(null);
  const getNewsImage = useApi(get_news_illustration);
  const date = new Date(news.created_at);

  const loc = i18n.language === 'cs' ? 'cz' : i18n.language;
  const newsDate = date.toLocaleDateString('de-DE');
  const newsTitle = news[`title_${loc}`] || news.title_cz || news.title_en || news.title_de || 'Untitled';
  const newsText = news[`text_${loc}`] || news.text_cz || news.text_en || news.text_de || '';

  const extractTextFromMarkdown = (markdown) => {
    if (!markdown) return '';
    return markdown
      .replace(/!\[.*?\]\(.*?\)/g, '')
      .replace(/\[([^\]]+)\]\([^\)]+\)/g, '$1')
      .replace(/#{1,6}\s+/g, '')
      .replace(/[*_~`]/g, '')
      .replace(/\n+/g, ' ')
      .trim();
  };

  const newsPreview = extractTextFromMarkdown(newsText);
  const membersOnly = news.private;

  useEffect(() => {
    if (news.illustration_filename && news.id) {
      getNewsImage.execute({ news_id: news.id });
    }
  }, [news.id, news.illustration_filename]);

  useEffect(() => {
    if (getNewsImage.data instanceof Blob && !getNewsImage.error) {
      const url = URL.createObjectURL(getNewsImage.data);
      setImageUrl(url);

      return () => {
        URL.revokeObjectURL(url);
      };
    } else if (getNewsImage.error) {
      setImageUrl(null);
    }
  }, [getNewsImage.data, getNewsImage.error]);

  return (
    <div className="news-card-wrapper" style={{ animationDelay: `${(index || 0) * 0.1}s` }}>
      <div className="news-card-stack news-card-stack-2"></div>
      <div className="news-card-stack news-card-stack-3"></div>

      <Link to={`/news/${news.id}`} style={{ textDecoration: 'none' }}>
        <article className="news-card">
          {news.illustration_filename && imageUrl && (
            <div className="news-card-image">
              <img src={imageUrl} alt={newsTitle} loading="lazy" />
            </div>
          )}

          <div className="news-card-tags">
            <span className="news-card-date">{newsDate}</span>
            {membersOnly && <span className="news-card-badge">{t('news.membersOnly')}</span>}
          </div>

          <div className="news-card-content">
            <h3 className="news-card-title">{newsTitle}</h3>
            {newsPreview && <p className="news-card-preview">{newsPreview}</p>}
            <div className="news-card-button">{t('news.readMore')}</div>
          </div>
        </article>
      </Link>
    </div>
  );
};

export default NewsCard;
